var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvestors(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Investors") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-/-S2-01-1_Idea-details_join_team-9",
    transform: "translate(-843.000000, -337.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(785.000000, 277.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Investors",
    transform: "translate(58.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#7834FF",
    cx: 22,
    cy: 22,
    r: 21.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "admin",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x35_6cc7d15-ccf8-46ac-b8b5-42e8bad5206c",
    transform: "translate(9.166667, 3.833333)",
    fill: "#8512FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.83333333,13.5 C3.15,13.5 0.15,10.5 0.15,6.81666667 C0.15,3.13333333 3.15,0.133333333 6.83333333,0.133333333 C10.5166667,0.133333333 13.5166667,3.13333333 13.5166667,6.81666667 C13.5166667,10.5 10.5166667,13.5 6.83333333,13.5 Z M6.83333333,1.46666667 C3.88333333,1.46666667 1.48333333,3.86666667 1.48333333,6.81666667 C1.48333333,9.76666667 3.88333333,12.1666667 6.83333333,12.1666667 C9.78333333,12.1666667 12.1833333,9.76666667 12.1833333,6.81666667 C12.1833333,3.86666667 9.78333333,1.46666667 6.83333333,1.46666667 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x38_34dcd48-729a-421f-93f2-e0d25f89d44f",
    transform: "translate(5.166667, 15.833333)",
    fill: "#8512FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8333333,12.1833333 C20.5,12.1833333 20.2166667,11.95 20.1666667,11.6166667 C19.6833333,8.36666667 18.4666667,5.68333333 16.6333333,3.9 C15.0333333,2.33333333 13,1.48333333 10.8833333,1.48333333 C7.23333333,1.48333333 2.58333333,4.13333333 1.48333333,11.6166667 C1.43333333,11.9833333 1.08333333,12.2333333 0.733333333,12.1833333 C0.366666667,12.1333333 0.116666667,11.7833333 0.166666667,11.4333333 C0.683333333,7.88333333 2.06666667,4.96666667 4.15,2.95 C6.01666667,1.15 8.41666667,0.15 10.8833333,0.15 C15,0.15 20.25,3.1 21.4833333,11.4166667 C21.5333333,11.7833333 21.2833333,12.1166667 20.9166667,12.1666667 C20.9,12.1833333 20.8666667,12.1833333 20.8333333,12.1833333 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestors);
export default __webpack_public_path__ + "static/media/investors.3b2cf8352ffe5af07093ab7ffb0f1a05.svg";
export { ForwardRef as ReactComponent };